import {css, cx} from "@panda/css";
import {Formik} from "formik";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {FormikForm, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {otherOption} from "../../../constants/otherOption";

interface IProps {
    title: string;
    text?: string;
    options: {
        value: string;
        label: string;
    }[];
    allowOwnAnswer?: boolean;
    ownAnswerLabel?: string;
    bottomSlot?: React.ReactNode;
    submitButtonText?: string;
    onSubmit: (values: {answers: string[]; ownAnswer?: string}) => Promise<void> | void;
}

const emptyInitialValues: {[key in string]: boolean} | {ownAnswer: string; showOwnAnswerInput: boolean} = {
    ownAnswer: "",
    showOwnAnswerInput: false
};
const validationSchema = Yup.object().shape({
    ownAnswer: Yup.string().min(3)
});

export const ModalSimpleSurveyLayout = (props: IProps) => {
    const {bottomSlot, title, text, options, allowOwnAnswer, ownAnswerLabel} = props;

    const onSubmit: IFormikSubmitFn<typeof emptyInitialValues> = async (values, formikHelpers) => {
        const {showOwnAnswerInput, ownAnswer, ...selectedAnswersObject} = values;

        const answersKeys = Object.keys(selectedAnswersObject);
        const answersValues = Object.values(selectedAnswersObject);
        const answers = answersKeys.filter((_, index) => answersValues[index]);

        await props.onSubmit({
            answers: showOwnAnswerInput ? answers.concat(otherOption.value) : answers,
            ...(showOwnAnswerInput ? {ownAnswer} : {})
        });
        formikHelpers.setSubmitting(false);
    };

    return (
        <div className={innerWrap}>
            <Text variant="headline_3" className={generalTextStyle}>
                {title}
            </Text>

            {text ? (
                <Text as="div" variant="body_copy_2" color="var(--colors-gray-700)" className={cx(generalTextStyle, generalTextStyleMargin)}>
                    {text}
                </Text>
            ) : null}

            <Formik onSubmit={onSubmit} initialValues={emptyInitialValues} validationSchema={validationSchema}>
                {(formikProps) => {
                    return (
                        <form className={formStyle} onSubmit={formikProps.handleSubmit}>
                            <div className={optionsWrapperStyle}>
                                {options.map((option) => (
                                    <FormikForm.Checkbox
                                        key={option.value}
                                        name={option.value}
                                        id={option.value}
                                        labelContent={
                                            <Text as="span" variant="info_txt_1">
                                                {option.label}
                                            </Text>
                                        }
                                        className={optionStyle}
                                    />
                                ))}

                                {allowOwnAnswer ? (
                                    <div className={cx(optionFlex, optionStyle)}>
                                        <FormikForm.Checkbox
                                            name="showOwnAnswerInput"
                                            id="showOwnAnswerInput"
                                            labelContent={
                                                <Text as="span" variant="info_txt_1">
                                                    {ownAnswerLabel ?? "Inny powód?"}
                                                </Text>
                                            }
                                        />
                                        {formikProps.getFieldProps("showOwnAnswerInput").value ? (
                                            <FormikForm.Textarea name="ownAnswer" id="ownAnswer" className={ownAnswerTextareaStyle} autoFocus />
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>

                            <div className={submitButtonWrapperStyle}>
                                <Button variant="filled_primary" className={buttonStyle} disabled={formikProps.isSubmitting}>
                                    {props.submitButtonText ?? "Zapisz"}
                                </Button>
                            </div>
                        </form>
                    );
                }}
            </Formik>
            {bottomSlot}
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    pt: "7",
    px: "1.5",
    pb: "1",

    md: {
        width: "65rem",
        height: "auto",
        pt: "4",
        px: "4",
        pb: "1",
        borderRadius: "1"
    }
});

const generalTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const generalTextStyleMargin = css({
    mb: 2,
    md: {
        mb: 0.5
    }
});

const optionsWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mt: 4
});

const optionStyle = css({
    p: 1,
    borderRadius: 1,
    backgroundColor: "var(--colors-gray-100)",
    width: "100%"
});

const optionFlex = css({
    display: "flex",
    flexDirection: "column"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});

const formStyle = css({
    mb: 4
});

const submitButtonWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: 4
});

const ownAnswerTextareaStyle = css({
    mt: 1
});
import {css, cx} from "@panda/css";
import {Formik} from "formik";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {FormikForm, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {otherOption} from "../../../constants/otherOption";

interface IProps {
    title: string;
    text?: string;
    options: {
        value: string;
        label: string;
    }[];
    allowOwnAnswer?: boolean;
    ownAnswerLabel?: string;
    bottomSlot?: React.ReactNode;
    submitButtonText?: string;
    onSubmit: (values: {answers: string[]; ownAnswer?: string}) => Promise<void> | void;
}

const emptyInitialValues: {[key in string]: boolean} | {ownAnswer: string; showOwnAnswerInput: boolean} = {
    ownAnswer: "",
    showOwnAnswerInput: false
};
const validationSchema = Yup.object().shape({
    ownAnswer: Yup.string().min(3)
});

export const ModalSimpleSurveyLayout = (props: IProps) => {
    const {bottomSlot, title, text, options, allowOwnAnswer, ownAnswerLabel} = props;

    const onSubmit: IFormikSubmitFn<typeof emptyInitialValues> = async (values, formikHelpers) => {
        const {showOwnAnswerInput, ownAnswer, ...selectedAnswersObject} = values;

        const answersKeys = Object.keys(selectedAnswersObject);
        const answersValues = Object.values(selectedAnswersObject);
        const answers = answersKeys.filter((_, index) => answersValues[index]);

        await props.onSubmit({
            answers: showOwnAnswerInput ? answers.concat(otherOption.value) : answers,
            ...(showOwnAnswerInput ? {ownAnswer} : {})
        });
        formikHelpers.setSubmitting(false);
    };

    return (
        <div className={innerWrap}>
            <Text variant="headline_3" className={generalTextStyle}>
                {title}
            </Text>

            {text ? (
                <Text as="div" variant="body_copy_2" color="var(--colors-gray-700)" className={cx(generalTextStyle, generalTextStyleMargin)}>
                    {text}
                </Text>
            ) : null}

            <Formik onSubmit={onSubmit} initialValues={emptyInitialValues} validationSchema={validationSchema}>
                {(formikProps) => {
                    return (
                        <form className={formStyle} onSubmit={formikProps.handleSubmit}>
                            <div className={optionsWrapperStyle}>
                                {options.map((option) => (
                                    <FormikForm.Checkbox
                                        key={option.value}
                                        name={option.value}
                                        id={option.value}
                                        labelContent={
                                            <Text as="span" variant="info_txt_1">
                                                {option.label}
                                            </Text>
                                        }
                                        className={optionStyle}
                                    />
                                ))}

                                {allowOwnAnswer ? (
                                    <div className={cx(optionFlex, optionStyle)}>
                                        <FormikForm.Checkbox
                                            name="showOwnAnswerInput"
                                            id="showOwnAnswerInput"
                                            labelContent={
                                                <Text as="span" variant="info_txt_1">
                                                    {ownAnswerLabel ?? "Inny powód?"}
                                                </Text>
                                            }
                                        />
                                        {formikProps.getFieldProps("showOwnAnswerInput").value ? (
                                            <FormikForm.Textarea name="ownAnswer" id="ownAnswer" className={ownAnswerTextareaStyle} autoFocus />
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>

                            <div className={submitButtonWrapperStyle}>
                                <Button variant="filled_primary" className={buttonStyle} disabled={formikProps.isSubmitting}>
                                    {props.submitButtonText ?? "Zapisz"}
                                </Button>
                            </div>
                        </form>
                    );
                }}
            </Formik>
            {bottomSlot}
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    pt: "7",
    px: "1.5",
    pb: "1",

    md: {
        width: "65rem",
        height: "auto",
        pt: "4",
        px: "4",
        pb: "1",
        borderRadius: "1"
    }
});

const generalTextStyle = css({
    textAlign: "center",
    md: {
        textAlign: "left"
    }
});

const generalTextStyleMargin = css({
    mb: 2,
    md: {
        mb: 0.5
    }
});

const optionsWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mt: 4
});

const optionStyle = css({
    p: 1,
    borderRadius: 1,
    backgroundColor: "var(--colors-gray-100)",
    width: "100%"
});

const optionFlex = css({
    display: "flex",
    flexDirection: "column"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});

const formStyle = css({
    mb: 4
});

const submitButtonWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: 4
});

const ownAnswerTextareaStyle = css({
    mt: 1
});
